import Vue3Lottie from 'vue3-lottie'
import type { UserModule } from '~/types'

export const install: UserModule = ({ app }) => {
  app.use(Vue3Lottie)
}
